import React, { FunctionComponent } from "react"
import { OverlayTrigger } from "react-bootstrap"
import ratmService from "../../utils/RATMService"
import RMTemplateSVG from "../../utils/svg/RMTemplateSVG"
import ratmTooltip from "../../utils/RATMTooltip"
import "./RoleAndTemplateManagementHeaderSwitchView.css"

const RoleAndTemplateManagementHeaderSwitchView: FunctionComponent<{}> = () => {

    const { manageState, state, rolesAndAssignmentsCopy, roleTemplatesCopy } = ratmService
    const { view } = state

    return (
        <div className="RoleAndTemplateManagementHeaderSwitchView">
            <OverlayTrigger placement="left" overlay={ratmTooltip("View roles")}>
                <div
                    className={
                        `RoleAndTemplateManagementHeaderSwitchViewItem ${view === 0 ?
                            "RoleAndTemplateManagementHeaderSwitchViewItemSelected RoleAndTemplateManagementHeaderSwitchViewItemSelectedLeft" :
                            "RoleAndTemplateManagementHeaderSwitchViewItemLeftNotSelected"}`}
                    onClick={() => manageState([
                        { key: "view", value: 0 },
                        { key: "roleTemplates", value: roleTemplatesCopy },
                        { key: "roleTemplates", value: roleTemplatesCopy },
                        { key: "searchInput", value: null }
                    ])}>
                    {/* <RMRoleSVG /> */}
                    <span className="material-icons c3cece8eae1f42568e79ef3168e94019">admin_panel_settings</span>
                </div>
            </OverlayTrigger>
            <div className="RoleAndTemplateManagementHeaderSwitchViewArrow">
                <span className={
                    `material-icons ${state.view === 0 ?
                        "RoleAndTemplateManagementHeaderSwitchViewArrowPointLeft" :
                        "RoleAndTemplateManagementHeaderSwitchViewArrowPointRight"}`
                }>
                    arrow_forward_ios
                </span>
            </div>
            <OverlayTrigger placement="right" overlay={ratmTooltip("View templates")}>
                <div
                    className={`RoleAndTemplateManagementHeaderSwitchViewItem ${view === 1 ?
                        "RoleAndTemplateManagementHeaderSwitchViewItemSelected RoleAndTemplateManagementHeaderSwitchViewItemSelectedRight" :
                        "RoleAndTemplateManagementHeaderSwitchViewItemRightNotSelected"}`}
                    onClick={() => manageState([
                        { key: "view", value: 1 },
                        { key: "rolesAndAssignments", value: rolesAndAssignmentsCopy },
                        { key: "roleTemplates", value: roleTemplatesCopy },
                        { key: "searchInput", value: null }
                    ])}>
                    <RMTemplateSVG />
                </div>
            </OverlayTrigger>
        </div>
    )
}

export default RoleAndTemplateManagementHeaderSwitchView